import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { OnlineCalcModel } from '../models/onlinecalc/onlinecalc.model';
import { CalcRunCtrl } from '../models/onlinecalc/calc-run-ctrl.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { CalcApi } from '../models/onlinecalc/calc-api.model';
import { RunCalcJson } from '../models/onlinecalc/run-calc-json.model';

@Injectable({
  providedIn: 'root'
})

export class OnlineCalcService {

  public onlineCalcModel = new OnlineCalcModel();
  public selectedCalRun = new CalcRunCtrl();
  private host = environment.apiUrl + "onlinecalc/calcmanage";
  public loggedinUser: string = '';
  public opts = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
  }

  

  public updateCalc1(formData: FormData): Observable<OnlineCalcModel> {
    return this.http.post<OnlineCalcModel>(`${this.host}/updatecalc`, formData);
  }

  public getCalcData(salesChannel: string, calRunId: string): Observable<OnlineCalcModel[]> {
    return this.http.get<OnlineCalcModel[]>(`${this.host}/getcalcdata/` + salesChannel + '/' + calRunId);
  }

  public getSalesChannels(): Observable<OnlineCalcModel[]> {
    return this.http.get<OnlineCalcModel[]>(`${this.host}/getsaleschanneldropdown`);
  }

  public getSalesChannelsValues(): Observable<string[]> {
    return this.http.get<string[]>(`${this.host}/getsaleschanneldropdownvalues`);
  }

  public getCalRunIds(): Observable<OnlineCalcModel[]> {
    return this.http.get<OnlineCalcModel[]>(`${this.host}/getcalruniddropdown`);
  }

  public getCalRunNames(): Observable<CalcRunCtrl[]> {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getrunControlnames`);
  }

  public getCalRunIDsBySalesChnl() {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getcalrunidlist`);
  }

  getCommPlans(salesChannels: string) {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getcommplanslist/${salesChannels}`);
  }

  getEmpIdByCommIdList(commPlanId: number,validFromDt:any) {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getempidbycommidlist/${commPlanId}/${validFromDt}`);
  }

  getEmpIdList(commPlanId: number,cal_run_id:any) {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getempidlist/${commPlanId}/${cal_run_id}`);
  }

  public getCalRunByRunId(runCtrlId: number): Observable<CalcRunCtrl[]> {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getrunControls/${runCtrlId}`);
  }

  public getInprogressCalRun(): Observable<CalcRunCtrl[]> {
    return this.http.get<CalcRunCtrl[]>(`${this.host}/getinprogressids`);
  }

  public saveRunCtrl(calcRunCtrlModels: CalcRunCtrl[]): Observable<CalcRunCtrl[]> {
    return this.http.post<CalcRunCtrl[]>(`${this.host}/addrunctrl`, calcRunCtrlModels);
  }

  public updateRunCtrl(calcRunCtrlModels: CalcRunCtrl[]): Observable<any> {
    return this.http.put<any>(`${this.host}/updaterunctrl`, calcRunCtrlModels);
  }

  public updateCalc(onlineCalcModel: OnlineCalcModel[]): Observable<CustomHttpRespone> {
    return this.http.put<CustomHttpRespone>(`${this.host}/updatecalc`, onlineCalcModel);
  }

  public deleteCommPlan(id: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deletecomdetailvalues/' + id;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public updateStatusToActiveInactive(Kpimaster: CalcRunCtrl[]): Observable<CalcRunCtrl> {
    return this.http.put<CalcRunCtrl>(`${this.host}/updatestatustoactiveinactive`, Kpimaster);
  }

  public saveCalcJson(calcApi: RunCalcJson) {
    // HOA-8442: route through the Java backend proxy (trusted *.run.app origin) instead of
    // the engine's private IP. The proxy authorizes the employee, logs in to the engine
    // server-side, and injects the engine token. We only send the employee id so the
    // backend can authorize; the engine credential is never built in the browser.
    const url = `${environment.apiUrl}engine/calc`;
    const payload: any = {
      ...calcApi,
      employeeId: localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')
    };
    return this.http.post<any>(url, payload);
  }


  public createForm(onlineCalcModel: OnlineCalcModel): FormData {
    const formData = new FormData();
    var adjustment_close_dt = (new Date(onlineCalcModel.adjustment_close_dt)).toUTCString();
    var dispute_close_dt = (new Date(onlineCalcModel.dispute_close_dt)).toUTCString();

    formData.append('calc_close_flag', onlineCalcModel.calc_close_flag);
    formData.append('comment', onlineCalcModel.comment);
    formData.append('adjustment_close_dt', adjustment_close_dt);
    formData.append('dispute_close_dt', dispute_close_dt);
    formData.append('comids', onlineCalcModel.comids);
    formData.append('calRunId', onlineCalcModel.calRunId);
    formData.append('ids', onlineCalcModel.ids);
    formData.append('currentUser', this.loggedinUser);

    return formData;
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

}